import { isObject } from '../../utils';
import MetricCalc from './MetricCalc';
var init = function (_a) {
    var _b = _a.appName, appName = _b === void 0 ? '' : _b;
    var MetricCalculator = new MetricCalc(appName);
    MetricCalculator.init();
    defineGlobals(MetricCalculator, appName);
};
var getInstance = function () { return window.MTPagePerformanceMonitor; };
var resetInstance = function () {
    window.MTPagePerformanceMonitor = undefined;
};
/**
 *
 * @param MetricCalculator
 * @param appName
 * Global object will have MTPagePerformanceMonitor
 */
var defineGlobals = function (MetricCalculator, appName) {
    window.MTPagePerformanceMonitor = {
        context: appName,
        getPerformanceData: MetricCalculator.getPerformanceData.bind(MetricCalculator),
        appTransitionStart: MetricCalculator.appTransitionStart.bind(MetricCalculator),
        addDataToScope: MetricCalculator.addDataToScope.bind(MetricCalculator),
        resetMetric: MetricCalculator.resetMetric.bind(MetricCalculator),
    };
};
/**
 *
 * @param location
 * preRouteUpdateMetrics will either reset performance metrics to empty
 * or will start a new begining for metric calculation.
 */
var preRouteUpdateMetrics = function (location) {
    var shouldSetTransitionStart = true;
    var fromLocation;
    if (isObject(location) && location.state) {
        var _a = location.state, _b = _a.isInternalApplicationRedirect, isInternalApplicationRedirect = _b === void 0 ? false : _b, prevLocation = _a.fromLocation;
        fromLocation = prevLocation;
        shouldSetTransitionStart = !isInternalApplicationRedirect;
    }
    if (window.MTPagePerformanceMonitor)
        shouldSetTransitionStart
            ? window.MTPagePerformanceMonitor.appTransitionStart(location, fromLocation)
            : window.MTPagePerformanceMonitor.resetMetric();
};
export { init, getInstance, resetInstance, preRouteUpdateMetrics };
//# sourceMappingURL=helpers.js.map